import { DatePipe } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'

import { Button } from 'primeng/button'
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'

import { ConfigureFiltersComponent } from '@app/components/configure-filters/configure-filters'
import { StaticDropDown } from '@app/components/generic/generic'
import { GenericColumnComponent } from '@app/components/generic/generic-column'
import { GenericListComponent } from '@app/components/generic/generic-list'

import { AuditLogEntry, AuditLogChanges } from './audit-log'
import { ACTIONS } from './audit-log.constants'
import { HistoryApi } from './history.api'

@Component({
  templateUrl: 'audit-log-list.html',
  imports: [
    ConfigureFiltersComponent,
    GenericListComponent,
    GenericColumnComponent,
    Button,
    DatePipe,
  ],
})
export class AuditLogListComponent extends GenericListComponent<AuditLogEntry> implements OnInit {
  public readonly dialogService = inject(DialogService)
  private readonly historyApi = inject(HistoryApi)
  private readonly ref = inject(DynamicDialogRef)
  public readonly config = inject(DynamicDialogConfig)

  code: string = ''
  override tableData: AuditLogEntry[] = []

  public actions: StaticDropDown[] = []

  override ngOnInit () {
    this.api = this.historyApi
    this.loading = true
    this.code = this.config.data?.code
    this.forceFilters = { code: this.code }

    this.loadStaticLists()
    super.ngOnInit()
  }

  private loadStaticLists () {
    this.actions = ACTIONS
  }

  formatChanges (dictChanges: AuditLogChanges) {
    const changes: any[] = []
    Object.keys(dictChanges).forEach(key =>
      changes.push(`<b>${key}:</b><br/> ${dictChanges[key][0]} -> ${dictChanges[key][1]}`),
    )
    return changes.join('<br/>')
  }

  onClose () {
    this.ref.close()
  }
}
